/** Row menu on the Compliance board: book today's Visit, or close with a written outcome. */
import { inject } from '@angular/core';
import { ActivityEntityName, ComplianceFlagBoardRow } from '@jms/model';
import { RightsService } from '@jms/utils/util.permissions';
import { bookComplianceVisit } from '@workbuddy/entities/shared.flag/commands/compliance.book.now.command';
import { openFlagResolveForm } from '@workbuddy/entities/shared.flag/section.relation/flag.forms';
import { EntityDataService, EntityDataServiceRaw } from '@workbuddy/services/entities';
import { Command } from '@workbuddy/ui/model';
import { ToastService } from '@workbuddy/ui/services';
import { WorkBuddyDialogService } from '@workbuddy/ui/v2/blocks/dialog';
import { EntityInspectors } from '@workbuddy/ui/v2/blocks/entity.inspector';
import { canActOnCompliance, isOpenCompliance } from './compliance.flag.command.support';

export const COMPLIANCE_BOOK_NOW_ROW_ID = 'compliance.bookNow';
export const COMPLIANCE_CLOSE_ROW_ID = 'compliance.close';

export function complianceFlagRowCommands(row: ComplianceFlagBoardRow): Command[] {

  if (!isOpenCompliance(row) || !canActOnCompliance(inject(RightsService))) return [];
  const raw = inject(EntityDataServiceRaw);
  const data = inject(EntityDataService);
  const dialogs = inject(WorkBuddyDialogService);
  const inspectors = inject(EntityInspectors);
  const toasts = inject(ToastService);

  return [
    new Command({ _id: COMPLIANCE_BOOK_NOW_ROW_ID, label: 'Book now', iconLeft: 'fa-regular fa-calendar-plus', action: () => { void bookComplianceVisit({ entities: raw, inspectors, toasts }, row._id); } }),
    new Command({
      _id: COMPLIANCE_CLOSE_ROW_ID,
      label: 'Close…',
      iconLeft: 'fa-regular fa-check',
      action: () => {
        void openFlagResolveForm(dialogs, raw, row, { outcomeRequired: true })
          .then(closed => closed && data.invalidate(ActivityEntityName.ComplianceFlag));
      },
    }),
  ];
}
